import React from "react";

export default function IconSave() {
  return (
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 24 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.2468 7.10615L18.7532 2.51885C18.2709 2.02657 17.6169 1.75 16.9349 1.75H2.57143C1.15125 1.75 0 2.92523 0 4.375V23.625C0 25.0748 1.15125 26.25 2.57143 26.25H21.4286C22.8488 26.25 24 25.0748 24 23.625V8.9623C24 8.26611 23.7291 7.59843 23.2468 7.10615ZM12 22.75C10.1065 22.75 8.57143 21.183 8.57143 19.25C8.57143 17.317 10.1065 15.75 12 15.75C13.8935 15.75 15.4286 17.317 15.4286 19.25C15.4286 21.183 13.8935 22.75 12 22.75ZM17.1429 6.09656V11.5938C17.1429 11.9562 16.855 12.25 16.5 12.25H4.07143C3.71641 12.25 3.42857 11.9562 3.42857 11.5938V5.90625C3.42857 5.54384 3.71641 5.25 4.07143 5.25H16.3136C16.4841 5.25 16.6476 5.31912 16.7681 5.44223L16.9546 5.63254C17.0143 5.69347 17.0616 5.76581 17.0939 5.84543C17.1262 5.92505 17.1429 6.01038 17.1429 6.09656Z"></path>
    </svg>
  );
}
